__turbopack_context__.v({
  "allProjects": "ProjectScopeDropdown-module__0FNBza__allProjects",
  "chevron": "ProjectScopeDropdown-module__0FNBza__chevron",
  "chipAvatar": "ProjectScopeDropdown-module__0FNBza__chipAvatar",
  "chipAvatarContainer": "ProjectScopeDropdown-module__0FNBza__chipAvatarContainer",
  "menuItemContent": "ProjectScopeDropdown-module__0FNBza__menuItemContent",
  "menuItemIcon": "ProjectScopeDropdown-module__0FNBza__menuItemIcon",
  "name": "ProjectScopeDropdown-module__0FNBza__name",
  "trigger": "ProjectScopeDropdown-module__0FNBza__trigger",
});
